module.exports = __webpack_public_path__ + "static/media/grz_chl_off.77035b32.svg";